import { Avatar, Checkbox, Meter, RoleBadge, StatusPill } from "./MemberParts";
import { IconDots } from "./icons";
import { relativeTime, usd, usdShort, type MemberVM } from "./memberModel";

type Props = {
  m: MemberVM;
  selected: boolean;
  onSelect: (id: number) => void;
  onOpen: (id: number) => void;
  onMenu: (id: number, anchor: HTMLElement) => void;
};

/** One card in the Card-grid layout — the alternate to the dense table. */
export function MemberCard({ m, selected, onSelect, onOpen, onMenu }: Props) {
  const capLabel =
    m.status === "pending"
      ? "—"
      : `${usd(m.spentCents)} / ${m.monthlyCapCents == null ? "∞" : usdShort(m.monthlyCapCents)}`;

  return (
    <div className={`ucard${selected ? " sel" : ""}`} onClick={() => onOpen(m.id)}>
      <div className="ucard-check">
        <Checkbox on={selected} onClick={() => onSelect(m.id)} label={`Select ${m.name}`} />
      </div>

      <div className="ucard-top">
        <Avatar m={m} size={40} />
        <div className="ucard-id">
          <div className="uident-name">
            {m.name}
            {m.you && <span className="you-tag">you</span>}
          </div>
          <div className="uident-email">{m.email}</div>
        </div>
      </div>

      <div className="ucard-meta">
        <RoleBadge role={m.role} />
        <StatusPill status={m.status} />
      </div>

      <div className="ucard-budget">
        <div className="bl">
          <span>this month</span>
          <span>{capLabel}</span>
        </div>
        {m.status !== "pending" && (
          <Meter spentCents={m.spentCents} capCents={m.monthlyCapCents} />
        )}
      </div>

      <div className="ucard-foot">
        <span className="ulast">{relativeTime(m.lastLoginAt)}</span>
        <button
          className="kebab"
          aria-label={`Actions for ${m.name}`}
          onClick={(e) => {
            e.stopPropagation();
            onMenu(m.id, e.currentTarget);
          }}
        >
          <IconDots />
        </button>
      </div>
    </div>
  );
}
